module.exports = __webpack_public_path__ + "static/media/icon-google.c8c02781.svg";